// Author Igor Veynik | Site: NexusLab.ru | Telegram: @thenexus | created 30.10.2026 | updated 30.10.2026
// src/main.js
import '@/styles/main.scss'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faTachometerAlt,
    faUsers,
    faShoppingCart,
    faCogs,
    faIndustry,
    faRepeat,
    faExchangeAlt,
    faBars,
    faChevronDown,
    faKey,
    faRightFromBracket,
    faAnglesLeft,
    faArrowRight,
    faArrowsRotate,
    faMagnifyingGlass,
    faPlus,
    faXmark,
    faUserSlash,
    faUser,
    faLock,
    faStore,
    faListCheck,
    faSliders,
    faBox,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
    faTachometerAlt, faUsers, faShoppingCart, faCogs, faIndustry, faRepeat, faExchangeAlt,
    faBars, faChevronDown, faKey, faRightFromBracket, faAnglesLeft, faArrowRight, faArrowsRotate,
    faMagnifyingGlass, faPlus, faXmark, faUserSlash, faUser, faLock, faStore, faListCheck, faSliders, faBox
)

const initApp = async () => {
    await store.dispatch('initializeStore')
    const app = createApp(App)
    app.component('font-awesome-icon', FontAwesomeIcon)
    app.use(store).use(router)
    app.mount('#app')
}

initApp()